import React from 'react';
import { motion } from 'framer-motion';
import { Gift, Sparkles, BookOpen, Footprints, Home, Target, Megaphone, CalendarCheck } from 'lucide-react';
const BONUSES = [{
  num: 1,
  title: 'Lectura de Partido para Arqueros',
  subtitle: 'Cómo anticipar jugadas antes que ocurran.',
  value: '$9.990',
  icon: BookOpen
}, {
  num: 2,
  title: 'Juego con los Pies para Arqueros Modernos',
  subtitle: 'Cómo convertirte en el primer creador de juego del equipo.',
  value: '$9.990',
  icon: Footprints
}, {
  num: 3,
  title: 'Entrenamiento de Reacción en Casa',
  subtitle: 'Cómo mejorar reflejos sin necesidad de cancha.',
  value: '$7.990',
  icon: Home
}, {
  num: 4,
  title: 'Guía de Posicionamiento Inteligente',
  subtitle: 'Cómo parecer más rápido posicionándote mejor.',
  value: '$7.990',
  icon: Target
}, {
  num: 5,
  title: 'El Manual del Arquero Líder',
  subtitle: 'Comunicación, presencia y autoridad en el equipo.',
  value: '$6.990',
  icon: Megaphone
}, {
  num: 6,
  title: 'Plan de Evolución de 30 Días',
  subtitle: 'Sistema paso a paso para evolucionar como arquero.',
  value: '$9.990',
  icon: CalendarCheck
}];
export const BonusesSection = () => {
  return <section className="py-12 md:py-16 px-4 bg-forest-900/60 border-y border-grass-400/20" data-id="element-11">
      <div className="max-w-5xl mx-auto" data-id="element-12">
        {/* Header */}
        <motion.div initial={{
        opacity: 0,
        y: 15
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-50px'
      }} transition={{
        duration: 0.4
      }} className="text-center mb-8" data-id="element-13">
          <div className="inline-flex items-center justify-center gap-2 bg-red-500 text-white font-anton uppercase tracking-wider text-xs px-4 py-1.5 rounded-full mb-4" data-id="element-14">
            <Sparkles size={14} className="fill-white" data-id="element-15" />
            Solo por el día de hoy
          </div>

          <h2 className="font-anton text-3xl md:text-5xl text-white uppercase tracking-wide leading-tight mb-2" data-id="element-16">
            6 BONOS <span className="text-grass-400" data-id="element-17">100% GRATIS</span>
          </h2>

          <p className="text-forest-200 text-sm md:text-base" data-id="element-18">
            Sumá{' '}
            <span className="text-grass-400 font-bold" data-id="element-19">
              más de $52.940 en contenido extra
            </span>{' '}
            sin costo adicional.
          </p>
        </motion.div>

        {/* Bonuses grid - compact */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-3 mb-6" data-id="element-20">
          {BONUSES.map(bonus => {
          const Icon = bonus.icon;
          return <div key={bonus.num} className="relative bg-forest-900 border border-grass-400/30 p-4 rounded-lg hover:border-grass-400/70 transition-colors" data-id="element-21">
                <div className="absolute top-0 right-0 bg-red-500 text-white font-anton text-[10px] uppercase tracking-wider px-2 py-0.5 rounded-bl-md rounded-tr-md" data-id="element-22">
                  GRATIS
                </div>

                <div className="flex items-start gap-3 pr-12" data-id="element-23">
                  <div className="bg-grass-400/15 border border-grass-400/30 p-2 rounded-md shrink-0" data-id="element-24">
                    <Icon className="text-grass-400" size={18} data-id="element-25" />
                  </div>
                  <div className="flex-1 min-w-0" data-id="element-26">
                    <div className="text-grass-400 font-anton text-[10px] tracking-wider mb-0.5" data-id="element-27">
                      BONO #{bonus.num}
                    </div>
                    <h3 className="font-bold text-sm text-white mb-1 leading-tight" data-id="element-28">
                      {bonus.title}
                    </h3>
                    <p className="text-forest-300 text-xs mb-2 leading-snug" data-id="element-29">
                      {bonus.subtitle}
                    </p>
                    <div className="flex items-center gap-1.5 text-[11px]" data-id="element-30">
                      <span className="text-forest-400 line-through font-semibold" data-id="element-31">
                        {bonus.value}
                      </span>
                      <span className="text-grass-400 font-bold uppercase" data-id="element-32">
                        → Gratis
                      </span>
                    </div>
                  </div>
                </div>
              </div>;
        })}
        </div>

        {/* Total value highlight - compact */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.97
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true,
        margin: '-50px'
      }} transition={{
        duration: 0.3
      }} className="max-w-md mx-auto bg-forest-950 border-2 border-grass-400 rounded-xl p-4 text-center" data-id="element-33">
          <div className="flex items-center justify-center gap-2 mb-1" data-id="element-34">
            <Gift className="text-grass-400" size={16} data-id="element-35" />
            <p className="text-forest-200 text-xs md:text-sm font-semibold uppercase tracking-wider" data-id="element-36">
              Valor total de los bonos
            </p>
          </div>
          <div className="flex items-baseline justify-center gap-3" data-id="element-37">
            <p className="text-forest-400 line-through text-lg font-bold" data-id="element-38">
              $52.940
            </p>
            <p className="font-anton text-3xl md:text-4xl text-grass-400 tracking-wide" data-id="element-39">
              HOY: $0
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
};